const textInputTagNames = new Set(['INPUT', 'TEXTAREA']);
const anotherInputTagNames = new Set(['SELECT']);

export function isTextInputElement(element: Element) {
  return textInputTagNames.has(element.tagName);
}

export function isInputElement(element: Element) {
  return (
    textInputTagNames.has(element.tagName) ||
    // проверка на компонент, который поднимает виртуальную клавиатуру
    anotherInputTagNames.has(element.tagName)
  );
}
